export const SET_HEADER_FIXED = 'BEAMLY/CCX/SET_HEADER_FIXED';
export const UNSET_HEADER_FIXED = 'BEAMLY/CCX/UNSET_HEADER_FIXED';
export const TOGGLE_NAVIGATION = 'BEAMLY/CCX/TOGGLE_NAVIGATION';
export const TOGGLE_COUNTRY_SELECTOR = 'BEAMLY/CCX/TOGGLE_COUNTRY_SELECTOR';
export const TOGGLE_SEARCH = 'BEAMLY/CCX/TOGGLE_SEARCH';
